const theme = {
  colors: {
    primary: "#04183C",
    secondary: "#56B149",
    white: "#FFF",
    lighterGray: "#FAFAFB",
    lightGray: "#E5E5E5",
    darkGray: "#333333",
  },
  fontSizes: {
    h1: "4.5rem",
    h2: "3.5rem",
    h3: "2.5rem",
    h5: "1.25rem",
    p: "1rem",
    span: ".75rem",
    mobileH1: "2.25rem",
    mobileH2: "1.75rem",
    mobileH3: "1.09rem",
    mobileH5: "1rem",
    mobileP: "0.875rem",
    mobileSpan: ".5rem",
  },
  fontWeights: {
    light: 300,
    normal: 400,
    semiBold: 600,
    bold: 700,
    heavy: 800,
    black: 900,
  },
  lineHeights: {
    none: 1,
    tight: 1.25,
    normal: 1.5,
    loose: 2,
  },
  letterSpacings: {
    normal: "normal",
    caps: "0.25em",
  },
  fontFamily: {
    sans: '"Montserrat", "sans-serif"',
  },
};

export default theme;
